import { Component, Output } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-privacy-policy-modal',
  standalone: true,
  imports: [],
  templateUrl: './privacy-policy-modal.component.html',
  styleUrl: './privacy-policy-modal.component.scss'
})
export class PrivacyPolicyModalComponent {

  open() {
    $('#privacyPolicyModal').modal('show');
  }

  // closeModal() {
  //   this.modalClose.emit({});
  // }
}
